import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { Alert, Icon } from "antd";
import { withNamespaces } from "react-i18next";

import isAuthenticated from "../../utils/isAuthenticated";
import { getDocumentApproveStatus } from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import classes from "../FinancePricesEditor/FinancePricesEditor.css";
import {
  getUserShortTimezone,
  getUserTimezone,
} from "../../reducers/user/selectors";
import moment from "moment-timezone";

class DocumentApproveStatus extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: null,
      isLoading: true,
      documentStatus: null,
    };
  }

  async componentDidMount() {
    try {
      const { data } = await getDocumentApproveStatus(this.props.id);
      this.setState({ documentStatus: data });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }

      this.setState({
        errorMessage: this.props.i18n.t("Something went wrong"),
      });
      console.log(e);
    }

    this.setState({
      isLoading: false,
    });
  }

  render() {
    const { errorMessage, isLoading, documentStatus } = this.state;

    console.log(documentStatus);

    return (
      <div>
        {isLoading && <Icon type="loading" />}

        {documentStatus && (
          <div>
            <div>
              {documentStatus.approved ? this.props.i18n.t("Approved") : this.props.i18n.t("Not approved")}
              {documentStatus.approved_dt && (
                <span>
                  &nbsp;by&nbsp;{get(documentStatus, "approved_by.username")}
                  &nbsp;at&nbsp;
                  {moment
                    .utc(documentStatus.approved_dt)
                    .tz(this.props.userTimezone || "UTC")
                    .format("YYYY/MM/DD HH:mm")}
                  &nbsp;
                  {this.props.userShortTimezone || "UTC"}
                </span>
              )}
            </div>

            {documentStatus.approved_by_signature && (
              <div>
                <img
                  src={documentStatus.approved_by_signature}
                  alt=""
                  width={150}
                />
              </div>
            )}
          </div>
        )}

        {errorMessage && (
          <Alert
            type="error"
            message={errorMessage}
            className={classes.alert}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userTimezone: getUserTimezone(state),
  userShortTimezone: getUserShortTimezone(state),
});
const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(DocumentApproveStatus))
);



// WEBPACK FOOTER //
// ./src/containers/DocumentsEditor/DocumentApproveStatus.js